import { Badge } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const SoonBadge = () => {
  const { t } = useTranslation()
  return <Badge colorPalette={'brand'}>{t('global:soon')}</Badge>
}
